<template>
  <div class="login-container">
    <h1>账号登录</h1>
    <!-- 用户名/手机号输入框 -->
    <van-field
      v-model="username"
      label="用户名/手机号"
      placeholder="请输入用户名或手机号"
      class="input-field"
    >
      <template #label>
        <van-icon name="contact" size="30" />
      </template>
    </van-field>

    <!-- 密码输入框 -->
    <van-field
      v-model="password"
      type="password"
      label="密码"
      placeholder="请输入密码"
      class="input-field"
    >
      <template #label>
        <van-icon name="lock" size="30" />
      </template>
    </van-field>

    <!-- 记住密码和忘记密码 -->
    <div class="remember-forget">
      <van-checkbox v-model="rememberPassword">记住密码</van-checkbox>
      <span @click="forgetPassword">忘记密码?</span>
    </div>

    <!-- 登录按钮 -->
    <van-button type="primary" block class="custom-button" @click="handleLogin">登 录</van-button>

    <!-- 第三方登录 -->
    <div class="third-party-login">
      <p>或通过以下方式登录</p>
      <van-icon name="wechat" size="30" color="#07c160" @click="loginWithWechat" />
      <van-icon name="phone" size="30" color="#ff4444" @click="loginWithPhone" />
    </div>

    <!-- 注册链接 -->
    <p class="register-link">还没有账号? <a href="#" @click="goToRegister">立即注册</a></p>
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import { useRouter } from 'vue-router';
  import h5Config from '@/config/config';

  // 初始化数据
  const username = ref('');
  const password = ref('');
  const rememberPassword = ref(false);

  // 路由实例
  const router = useRouter();

  // 处理登录逻辑
  const handleLogin = () => {
    // 这里可以添加登录请求逻辑
    console.log('登录:', username.value, password.value);
  };

  // 忘记密码处理
  const forgetPassword = () => {
    // 这里可以添加忘记密码逻辑
    console.log('忘记密码');
  };

  // 微信登录处理
  const loginWithWechat = () => {
    // 这里可以添加微信登录逻辑
    console.log('微信登录');
  };

  // 手机登录处理
  const loginWithPhone = () => {
    // 这里可以添加手机登录逻辑
    console.log('手机登录');
  };

  // 跳转到注册页面
  const goToRegister = () => {
    router.push('/register');
  };
</script>

<style scoped>
  .input-field {
    margin-bottom: 20px;
    border-radius: 8px;
  }

  /* 增大输入框高度并调整字体 */
  ::v-deep .input-field .van-field__control {
    height: 50px;
    font-size: 18px; /* 进一步增大输入文字字号 */
    padding: 0 15px;
  }

  /* 调整placeholder文字大小 */
  ::v-deep .input-field .van-field__control::placeholder {
    font-size: 18px;
  }

  /* 图标容器垂直居中 */
  ::v-deep .input-field .van-field__label {
    width: 30px;
    min-width: 30px;
    padding-right: 0;
    display: flex;
    align-items: center; /* 垂直居中 */
    justify-content: center; /* 水平居中 */
  }

  /* 调整输入框内容左侧间距 */
  ::v-deep .input-field .van-field__value {
    padding-left: 10px;
  }

  /* 增大第三方登录图标尺寸 */
  .third-party-login .van-icon {
    margin: 0 15px;
    size: 40px;
  }

  /* 自定义按钮样式扩展 */
  .custom-button {
    background-color: v-bind('h5Config.themeColor');
    border-radius: 30px; /* 增大圆角 */
    font-size: 20px; /* 增大按钮字体 */
    height: 50px; /* 保持按钮高度与输入框一致 */
    display: flex;
    align-items: center; /* 文字垂直居中 */
    justify-content: center; /* 文字水平居中 */
  }

  .login-container {
    padding: 20px;
  }

  .remember-forget {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }

  /* 调整第三方登录区域样式 */
  .third-party-login {
    text-align: center;
    margin-top: 20px;
  }

  .register-link {
    text-align: center;
    margin-top: 20px;
  }
</style>
